import { render, staticRenderFns } from "./EventLogDetails.vue?vue&type=template&id=24985462&scoped=true&"
import script from "./EventLogDetails.vue?vue&type=script&lang=js&"
export * from "./EventLogDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24985462",
  null
  
)

export default component.exports